export const NOTIFICATION_CATEGORIES = {
    ALL: "ALL",
    KNOWLEDGE_BASE: "KNOWLEDGE BASE",
    DEPENDENCY_CONTROL: "DEPENDENCY CONTROL",
};
